import Select from 'react-select'
import { ILanguageSelectorProps } from './language-selector-props.interface'
import { useTranslation } from 'react-i18next'
import { storageService } from 'services'
import { LANGUAGES } from 'interfaces'

const LanguageSelector: React.FC<ILanguageSelectorProps> = (props) => {
  const { i18n } = useTranslation()

  let lngIndex = LANGUAGES.findIndex((o) => o.value === i18n.resolvedLanguage)

  lngIndex = lngIndex < 0 ? 0 : lngIndex

  return (
    <div className="edisu-language-selector">
      <Select
        options={LANGUAGES}
        isSearchable={false}
        {...props}
        defaultValue={LANGUAGES[lngIndex]}
        closeMenuOnSelect={true}
        hideSelectedOptions={true}
        onChange={(e) => {
          storageService.saveLanguage(e?.value ?? 'it')
          document.location.reload()
        }}
      />
    </div>
  )
}

export default LanguageSelector
